import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  create_customer_account: { status: "idle" },
};

export const create_customer_account_Slice = createSlice({
  name: "create_customer_account",
  initialState,
  reducers: {
    success_create_customer_account: (state, action) => {
      state.create_customer_account = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_create_customer_account: (state, action) => {
      state.create_customer_account = { status: app_consts.FAIL, message: action.payload };
    },
    reset_create_customer_account: (state) => {
      state.create_customer_account = { status: app_consts.IDLE };
    },
    loading_create_customer_account: (state) => {
      state.create_customer_account = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_create_customer_account,
  fail_create_customer_account,
  reset_create_customer_account,
  loading_create_customer_account,
} = create_customer_account_Slice.actions;

export default create_customer_account_Slice.reducer;
